<h1 mat-dialog-title>{{ 'protocolEdit.attachments.dialog.title' | translate }}</h1>
<form>
  <div mat-dialog-content class="air-theme">
    <mat-form-field class="campoFormulario">
      <input matInput placeholder="{{ 'protocolEdit.attachments.dialog.name' | translate }}" name="attName"
        [(ngModel)]="data.essayFile.name">
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="getTheme()">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>
      {{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>